// 2P AI — stato del tema. Il valore iniziale è impostato da public/theme-init.js (anti-flash)
// prima del render; qui leggiamo/aggiorniamo data-theme, persistiamo su localStorage e notifichiamo
// i componenti via un CustomEvent. La meta theme-color segue il tema per la chrome del browser/PWA.
import { useEffect, useState } from 'react';

export type Theme = 'light' | 'dark';
const KEY = 'p2ai-theme';
const EVT = 'p2ai-theme';
const BG: Record<Theme, string> = { dark: '#0B0F14', light: '#ECF1F5' };

export function currentTheme(): Theme {
  return document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
}

export function setTheme(t: Theme): void {
  document.documentElement.setAttribute('data-theme', t);
  try { localStorage.setItem(KEY, t); } catch { /* ignore */ }
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', BG[t]);
  window.dispatchEvent(new CustomEvent<Theme>(EVT, { detail: t }));
}

export function toggleTheme(): void {
  setTheme(currentTheme() === 'dark' ? 'light' : 'dark');
}

export function useTheme(): [Theme, () => void] {
  const [theme, setLocal] = useState<Theme>(currentTheme);
  useEffect(() => {
    const handler = (e: Event) => setLocal((e as CustomEvent<Theme>).detail);
    window.addEventListener(EVT, handler as EventListener);
    return () => window.removeEventListener(EVT, handler as EventListener);
  }, []);
  return [theme, toggleTheme];
}
